var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},_vm._l((_vm.sort),function(li,index){return _c('div',{key:index},[(li.LinkType == 3)?_c('swipe',{attrs:{"banner":_vm.images}}):_vm._e(),_vm._v(" "),(li.LinkType == 4)?_c('tablist',{attrs:{"tab":_vm.list}}):_vm._e(),_vm._v(" "),(li.LinkType == 2)?_c('cardlist',{attrs:{"card":_vm.card}}):_vm._e()],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26cb8fa6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index.vue
// module id = null
// module chunks = 